<template>
  <v-container fluid class="pa-2">

    <!-- Plava traka, kao na ostalim ekranima -->
    <div class="traka">
      <h2 class="naslov">{{ $store.state.editItem === 1 ? langC.Edit : lang.NewTask }}</h2>
      <div class="podatak">
        {{ lang.TaskAssignedBy }}: {{ $store.getters.NeedFullUser }}
        <span v-if="task.taskOpenDate"> &middot; {{ localDate(task.taskOpenDate) }}</span>
      </div>
    </div>

    <v-card tile>
      <v-card-text class="pt-4">

        <v-row>
          <!-- lijevo: o cemu se radi -->
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              :label="lang.ShortDesc"
              required
              :rules="[required]"
              v-model="task.taskShortDescription"
              dense
            ></v-text-field>

            <v-select
              :items="tasktypes"
              v-model="selectTT"
              :label="lang.TaskType"
              item-text="taskTypeDescription"
              item-value="id"
              return-object
              clearable
              dense
            ></v-select>

            <v-autocomplete
              :items="partners"
              v-model="selectPa"
              :label="lang.TaskPartner"
              item-text="partnerName"
              item-value="id"
              return-object
              clearable
              dense
            ></v-autocomplete>

            <v-textarea
              :label="lang.DetDesc"
              v-model="task.taskDetailDescription"
              rows="3"
              dense
            ></v-textarea>
          </v-col>

          <!-- desno: kome i do kada -->
          <v-col cols="12" sm="6" class="py-0">
            <!-- Trazi se i po imenu, ne samo po e-mailu: popis je dosad
                 pokazivao samo adresu, pa se osoba po imenu nije mogla naci. -->
            <v-autocomplete
              :items="users"
              v-model="selectUs"
              :label="lang.TaskForUser"
              :item-text="prikazKorisnika"
              item-value="id"
              return-object
              clearable
              dense
            ></v-autocomplete>

            <!-- Bez ovoga operater ne zna gdje je zadatak zavrsio kad nikoga
                 ne odabere - a dosad je u tom slucaju ostajao nicij. -->
            <div class="napomena mb-3" v-if="!selectUs || !selectUs.id">
              <span v-if="zaduzenaOsoba">
                {{ lang.TaskResponsibleHint }} &mdash;
                <b>{{ zaduzenaOsoba }}</b>
              </span>
              <span v-else class="orange--text text--darken-3">
                {{ langC.TaskNobodyAssigned }}
              </span>
            </div>

            <v-autocomplete
              :items="users"
              v-model="selectUs2"
              :label="lang.TaskInfoSend"
              :item-text="prikazKorisnika"
              item-value="id"
              return-object
              clearable
              dense
            ></v-autocomplete>

            <v-row dense>
              <v-col cols="7" class="py-0">
                <v-text-field
                  :label="lang.ForDate"
                  type="date"
                  v-model="task.taskForDate"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="5" class="py-0">
                <v-text-field
                  :label="lang.ForTime"
                  type="time"
                  v-model="task.taskForTime"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-select
              dense
              v-model="task.taskColor"
              :items="colors"
              item-text="text"
              item-value="value"
              label="Boja"
            ></v-select>
          </v-col>
        </v-row>

        <!-- Zadatak koji je vec obavljen: posao je stigao mimo sustava
             (poziv, e-mail), odraden je i samo se evidentira. -->
        <div class="obavljeno-blok">
          <v-checkbox
            v-model="vecObavljeno"
            :label="lang.TaskAlreadyDone"
            hide-details
            class="mt-0 pt-0"
            @change="naVecObavljeno"
          ></v-checkbox>
          <div class="napomena ml-8">{{ lang.TaskAlreadyDoneHint }}</div>

          <div v-if="vecObavljeno" class="mt-3">
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-row dense>
                  <v-col cols="6">
                    <v-text-field
                      :label="lang.SpentHours"
                      v-model.number="task.taskSpentHours"
                      type="number"
                      step="0.25"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      :label="lang.ChargeHours"
                      v-model.number="task.taskChargeHours"
                      type="number"
                      step="0.25"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="posaljiObavijest"
                  :label="lang.TaskNotify"
                  hide-details
                  class="mt-0 pt-0"
                ></v-checkbox>
                <v-text-field
                  v-if="posaljiObavijest"
                  :label="lang.TaskNotifyEmail"
                  v-model="task.taskNotifyEmail"
                  :placeholder="direktorEmail"
                  persistent-placeholder
                  dense
                  class="mt-2"
                ></v-text-field>
                <div v-if="posaljiObavijest && !nemaAdrese" class="napomena">
                  {{ lang.TaskNotifyHint }}
                </div>
                <!-- Bez adrese bi slanje palo tek nakon spremanja, pa se to
                     kaze odmah. -->
                <div v-if="posaljiObavijest && nemaAdrese" class="napomena orange--text text--darken-3">
                  {{ langC.TaskNotifyNoAddress }}
                </div>
              </v-col>
            </v-row>

            <!-- Operater vidi sto ce direktor dobiti prije nego posalje. -->
            <div v-if="posaljiObavijest" class="pregled-poruke">
              <div class="pregled-naslov">{{ lang.TaskMessagePreview }}</div>
              <b>Obavljeno: {{ task.taskShortDescription }}<span v-if="nazivFirme"> ({{ nazivFirme }})</span></b><br>
              <span v-if="nazivFirme">Firma: {{ nazivFirme }}</span>
              <span v-if="selectPa && selectPa.partnerName"> &middot; Partner: {{ selectPa.partnerName }}</span>
              <span v-if="selectTT && selectTT.taskTypeDescription"> &middot; Vrsta: {{ selectTT.taskTypeDescription }}</span>
              <br>
              Obavljeno: {{ localDate(new Date()) }} &middot; Obavio: {{ $store.getters.NeedFullUser }}
              <span v-if="task.taskSpentHours"><br>Utrošeno sati: {{ task.taskSpentHours }}</span>
              <span v-if="task.taskChargeHours"> &middot; Za naplatu sati: {{ task.taskChargeHours }}</span>
            </div>
          </div>
        </div>

        <!-- Rijetko popunjeno stoji sklopljeno. Mjereno na 2.300 zadataka:
             zaposlenik 0,4 %, odjel i problem ispod 1 %. -->
        <v-expansion-panels flat multiple class="mt-3 sklopivo">
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ lang.TaskEmp }}
              <template v-slot:actions><v-icon small>mdi-chevron-down</v-icon></template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-autocomplete
                :items="employes"
                v-model="selectEm"
                :label="lang.TaskEmp"
                item-text="hashtag"
                item-value="id"
                return-object
                clearable
                dense
              ></v-autocomplete>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ lang.TaskDepartment }}
              <template v-slot:actions><v-icon small>mdi-chevron-down</v-icon></template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-select
                :items="taskdepartments"
                v-model="selectTD"
                :label="lang.TaskDepartment"
                item-text="taskDepartmentDescription"
                item-value="id"
                return-object
                clearable
                dense
              ></v-select>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="task.taskPublic"
                    :label="lang.TaskPublic"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="task.taskToDoList"
                    :label="lang.TaskToDoList"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ lang.TaskHaveProblem }}
              <template v-slot:actions><v-icon small>mdi-chevron-down</v-icon></template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-checkbox
                v-model="task.taskNotFinished"
                :label="lang.TaskHaveProblem"
                color="warning"
                hide-details
              ></v-checkbox>
              <v-text-field
                :label="lang.TaskProblem"
                v-model="task.taskNotFinishedReason"
                dense
                class="mt-3"
              ></v-text-field>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="pink darken-2" v-html="error" />
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="tasklist">{{ langC.Back }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!formIsValid" :loading="spremam" @click="register">
          {{ langC.Save }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="poruka.vidi" :color="poruka.boja" :timeout="5000">
      {{ poruka.tekst }}
    </v-snackbar>
  </v-container>
</template>

<script>
import dayjs from 'dayjs'
import EmployeeService from '@/services/EmployeeService'
import TaskTypeService from '@/services/TaskTypeService'
import TaskDepartmentService from '@/services/TaskDepartmentService'
import UserService from '@/services/UserService'
import { prikazKorisnika } from '@/snippets/korisnikPrikaz'
import TaskService from '@/services/TaskService'
// import EmailService from '@/services/EmailService'
import langEn from './taskDescEn'
import langHr from './taskDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import { testLastUpdate } from '../../services/TestLastUpdate'

export default {
  name: 'taskcreate',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      lang: {},
      langC: {},
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date1: null,
      date2: null,
      msg: '',
      valid: true,
      task: {
        CompanyId: 0,
        CompanyNameDatabase: '',
        BusinessYear: 0,
        UserId: 0,
        email: '',
        First: '',
        Last: '',
        EmployeeId: 0,
        Employeeemail: '',
        Employeehashtag: '',
        partnerId: 0,
        partnerName: '',
        partnerNameShort: '',
        taskTypeID: 0,
        taskTypeDescription: '',
        taskDepartmentID: 0,
        taskDepartmentDescription: '',
        taskShortDescription: '',
        taskDetailDescription: '',
        taskOpenDate: null,
        taskOpenTime: null,
        taskForDate: null,
        taskForTime: null,
        taskAlarmDate: null,
        taskAlarmTime: null,
        taskFor1UserId: 0,
        taskFor1Useremail: '',
        taskFor1UserSendEmail: false,
        taskFor2UserId: 0,
        taskFor2Useremail: '',
        taskFor2UserSendEmail: false,
        taskFor3UserId: 0,
        taskFor3Useremail: '',
        taskFor3UserSendEmail: false,
        taskFor4UserId: 0,
        taskFor4Useremail: '',
        taskFor4UserSendEmail: false,
        taskFor5UserId: 0,
        taskFor5Useremail: '',
        taskFor5UserSendEmail: false,
        taskClosedDate: null,
        taskClosedTime: null,
        taskClosedUserId: 0,
        taskClosed: false,
        taskClosedSendEmail: false,
        taskSpentHours: 0,
        taskChargeHours: 0,
        taskCharged: false,
        taskChargedByUserId: 0,
        taskChargedByUseremail: '',
        taskChargedDate: null,
        taskChargedTime: null,
        taskNotFinished: false,
        taskNotFinishedReason: '',
        taskPublic: false,
        taskColor: 'blue',
        taskEndDate : null,
        taskToDoList: false,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
        LastUpdateBy: '',
        LastUpdate: null
      },
      temptask: {},
      task2: {},
      error: null,
      localError: false,
      newUser: {},
      confpassword: '',
      size: 'sm',
      privitems: [
        { text: '1 max privileges', value: 1 },
        { text: '2 medium to max privileges', value: 2 },
        { text: '3 medium privileges', value: 3 },
        { text: '4 low to midium privileges', value: 4 },
        { text: '5 low privileges', value: 5 }
      ],
      required: (value) => !!value || 'Required.',
      partners: [],
      employes: [],
      tasktypes: [],
      colors: [],
      taskdepartments: [],
      users: [],
      CompanyId: 0,
      selectPa: {},
      selectEm: {},
      selectTT: {},
      selectTD: {},
      selectUs: {},
      selectUs2: {},
      selectUs3: {},
      mainQuery: {
        CompanyId: 1
      },
      havePath: '',
      showDetails: false,
      // Zadatak koji je vec obavljen - posao je stigao mimo sustava, odraden je
      // i samo se evidentira. Sprema se zatvoren.
      vecObavljeno: false,
      posaljiObavijest: false,
      spremam: false,
      poruka: {vidi: false, tekst: '', boja: 'success'},
      // Podaci firme za napomenu o zaduzenoj osobi i za zadanu adresu obavijesti.
      nazivFirme: '',
      direktorEmail: '',
      zaduzenaOsoba: ''
    }
  },
  components: {
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = langEn
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = langHr
      this.langC = commHr;
    }
    // need five arrays with partners, employes, tasktype, taskdepartment, users
    if (this.$store.state.companyid) {
      this.CompanyId = await this.$store.state.companyid
      this.mainQuery.CompanyId = await this.$store.state.companyid
    }

    // Tko je zaduzen za ovu firmu i kome ide obavijest. Bez toga operater ne
    // zna gdje zadatak zavrsi kad izvrsitelja ne odabere.
    try {
      const firma = this.$store.state.companyActiv
      if (firma) {
        this.nazivFirme = firma.CompanyName ? firma.CompanyName : ''
        this.direktorEmail = firma.CompanyDirectorEmail ? firma.CompanyDirectorEmail : ''
        this.zaduzenaOsoba = firma.CompanyTaskEmail ? firma.CompanyTaskEmail : ''
      }
    } catch (err) {
      // eslint-disable-next-line
      console.log('podaci firme za zadatak', err)
    }
    if (this.$store.state.editItem === 0) {
      if (this.CompanyId > 0) {
        await testLastUpdate()
        if (this.$store.state.partnerStore) {
          this.partners = this.$store.state.partnerStore
        }
        //this.partners = (await PartnerService.index()).data.partners
        this.employes = (await EmployeeService.choose(this.mainQuery)).data.employes
        this.tasktypes = (await TaskTypeService.choose(this.mainQuery)).data.taskTypes
        this.taskdepartments = (await TaskDepartmentService.choose(this.mainQuery)).data.taskDepartments
        this.users = (await UserService.choose(this.mainQuery)).data.users
        // console.log(this.partners)
        // console.log(this.tasktypes)
        // console.log(this.taskdepartments)
        // console.log(this.users)
      }
      if (this.$store.state.user.id) {
        this.task.UserId = this.$store.state.user.id
      }
      if (this.$store.state.user.email) {
        this.task.email = this.$store.state.user.email
      }
      if (this.$store.state.user.First) {
        this.task.First = this.$store.state.user.First
      }
      if (this.$store.state.user.Last) {
        this.task.Last = this.$store.state.user.Last
      }
      if (this.$store.state.companyid) {
        this.task.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.companyName) {
        this.task.CompanyNameDatabase = this.$store.state.companyName
      }
      if (this.$store.state.businessYear) {
        this.task.BusinessYear = this.$store.state.businessYear
      }
    }
    if (this.$store.state.editItem === 1) {
      const dbTask = await TaskService.show(this.$store.state.taskid)
      this.task = dbTask.data.task
      if (this.$store.state.companyid) {
        this.CompanyId = await this.$store.state.companyid
        this.mainQuery.CompanyId = await this.$store.state.companyid
      }
      if (this.task.taskOpenDate) {
        this.loctaskOpenDate = dayjs(this.task.taskOpenDate).format('DD.MM.YYYY')
      }
      // if (this.task.taskForDate) {
      //   this.loctaskForDate = dayjs(this.task.taskForDate).format('DD.MM.YYYY')
      // }
      if (this.task.taskAlarmDate) {
        this.loctaskAlarmDate = dayjs(this.task.taskAlarmDate).format('DD.MM.YYYY')
      }
      if (this.task.taskClosedDate) {
        this.loctaskClosedDate = dayjs(this.task.taskClosedDate).format('DD.MM.YYYY')
      }
      this.locCreatedAt = dayjs(this.task.createdAt).format('DD.MM.YYYY HH:mm')
      this.locUpdatedAt = dayjs(this.task.updatedAt).format('DD.MM.YYYY HH:mm')

      if (this.$store.state.companyid) {
        this.CompanyId = await this.$store.state.companyid
        this.mainQuery.CompanyId = await this.$store.state.companyid
      }
      if (this.CompanyId > 0) {
        await testLastUpdate()
        if (this.$store.state.partnerStore) {
          this.partners = this.$store.state.partnerStore
        }
        //this.partners = (await PartnerService.index()).data.partners
        this.employes = (await EmployeeService.choose(this.mainQuery)).data.employes
        this.tasktypes = (await TaskTypeService.choose(this.mainQuery)).data.taskTypes
        this.taskdepartments = (await TaskDepartmentService.choose(this.mainQuery)).data.taskDepartments
        this.users = (await UserService.choose(this.mainQuery)).data.users
        // console.log(this.partners)
        // console.log(this.tasktypes)
        // console.log(this.taskdepartments)
        // console.log(this.users)
      }
      if (this.task.partnerId) {
        this.selectPa = { partnerName: this.task.partnerName,
          partnerNameShort: '',
          partnerNameDatabase: '',
          partneremail: '',
          id: this.task.partnerId}
      }
      if (this.task.taskTypeID) {
        this.selectTT = {
          taskTypeDescription: this.task.taskTypeDescription,
          CompanyId: this.CompanyId,
          id: this.task.taskTypeID
        }
      }
      if (this.task.taskDepartmentID) {
        this.selectTD = {
          taskDepartmentDescription: this.task.taskDepartmentDescription,
          CompanyId: this.CompanyId,
          id: this.task.taskDepartmentID
        }
      }
      if (this.task.taskFor1UserId) {
        this.selectUs = {
          id: this.task.taskFor1UserId,
          email: this.task.taskFor1Useremail,
          First: '',
          Last: '',
          AccessLevel: '',
          CompanyId: this.CompanyId
        }
      }
      if (this.task.taskFor2UserId) {
        this.selectUs2 = {
          id: this.task.taskFor2UserId,
          email: this.task.taskFor2Useremail,
          First: '',
          Last: '',
          AccessLevel: '',
          CompanyId: this.CompanyId
        }
      }
      if (this.task.taskFor3UserId) {
        this.selectUs3 = {
          id: this.task.taskFor3UserId,
          email: this.task.taskFor3Useremail,
          First: '',
          Last: '',
          AccessLevel: '',
          CompanyId: this.CompanyId
        }
      }
      if (this.task.EmployeeId) {
        this.selectEm = {
          hashtag: this.task.Employeehashtag,
          eemail: this.task.Employeeemail,
          First: '',
          Last: '',
          CompanyId: this.CompanyId,
          VatID: '',
          id: this.task.EmployeeId
        }
      }
    }
    let locDate1 = new Date()
    locDate1.getDate()
    locDate1.getMonth() + 1
    locDate1.getFullYear()
    this.task.taskOpenDate = dayjs().format('YYYY-MM-DD')
    this.colors = this.$store.state.colors ? this.$store.state.colors : []
  },
  computed: {
    // Ni upisane adrese ni direktora na firmi - obavijest nema kamo.
    nemaAdrese () {
      const upisana = this.task.taskNotifyEmail ? String(this.task.taskNotifyEmail).trim() : ''
      return upisana === '' && !this.direktorEmail
    },
    formIsValid () {
      return this.task.email !== '' &&
        this.task.First !== '' &&
        this.task.Last !== '' &&
        this.task.activ !== ''
    }
  },
  methods: {
    prikazKorisnika,
    showDets() {
      this.showDetails = !this.showDetails
    },
    // Kvacica "vec obavljen" zatvara zadatak i nudi obavijest. Skidanjem
    // kvacice zadatak se vraca u otvorene.
    naVecObavljeno (upaljeno) {
      this.task.taskClosed = upaljeno === true
      if (upaljeno) {
        if (!this.task.taskNotifyEmail && this.direktorEmail) {
          this.task.taskNotifyEmail = this.direktorEmail
        }
        // Obavijest je i smisao ove kvacice, pa je ukljucena po zadanom.
        this.posaljiObavijest = true
      } else {
        this.posaljiObavijest = false
      }
    },
    localDate (d) {
      return d ? dayjs(d).format('DD.MM.YYYY') : ''
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async register () {
      try {
        // write new task to database
        this.localError = false
        if (this.selectPa.id) {
          this.task.partnerId = this.selectPa.id
        }
        if (this.selectPa.partnerName) {
          this.task.partnerName = this.selectPa.partnerName
        }
        if (this.selectEm.id) {
          this.task.EmployeeId = this.selectEm.id
        }
        if (this.selectEm.eemail) {
          this.task.Employeeemail = this.selectEm.eemail
        }
        if (this.selectEm.hashtag) {
          this.task.Employeehashtag = this.selectEm.hashtag
        }
        if (this.selectTT.id) {
          this.task.taskTypeID = this.selectTT.id
        }
        if (this.selectTT.taskTypeDescription) {
          this.task.taskTypeDescription = this.selectTT.taskTypeDescription
        }
        if (this.selectTD.id) {
          this.task.taskDepartmentID = this.selectTD.id
        }
        if (this.selectTD.taskDepartmentDescription) {
          this.task.taskDepartmentDescription = this.selectTD.taskDepartmentDescription
        }
        if (this.selectUs.id) {
          this.task.taskFor1UserId = this.selectUs.id
          // this.task2 = Object.assign({}, this.task)
          // this.task2.UserId = this.selectUs.id
          // this.task2.First = this.selectUs.First
          // this.task2.Last = this.selectUs.Last
          // this.task2.For5UserUserId = this.$store.state.user.id
        }
        if (this.selectUs2.id) {
          this.task.taskFor2UserId = this.selectUs2.id
          this.task.taskFor2Useremail = this.selectUs2.email
        }
        if (this.selectUs3.id) {
          this.task.taskFor3UserId = this.selectUs3.id
          this.task.taskFor3Useremail = this.selectUs3.email
        }
        if (this.selectUs.email) {
          this.task.taskFor1Useremail = this.selectUs.email
          // this.task2.email = this.selectUs.email
          // this.task2.taskFor5Useremail = this.$store.state.user.email
        }
        if (!this.task.taskForDate) {
          this.task.taskForDate = new Date()
        }
        this.spremam = true

        // Zadatak koji je vec obavljen sprema se zatvoren, s podacima o
        // zatvaranju - inace bi ostao u popisu kao posao koji tek slijedi.
        if (this.vecObavljeno) {
          this.task.taskClosed = true
          this.task.taskClosedDate = new Date()
          this.task.taskClosedUserId = this.$store.getters.NeedUserID
        }

        let zapisaniId = this.task.id
        let zaduzenje = ''

        if (this.$store.state.editItem === 0) {
          delete this.task.id
          const resTask = await TaskService.post(this.task)
          if (resTask && resTask.data) {
            zapisaniId = resTask.data.id
            zaduzenje = resTask.data.zaduzenje ? resTask.data.zaduzenje : ''
          }
          if (resTask && this.task2.UserId  && resTask.data) {
            this.task2.FreeF1 = resTask && resTask.data && resTask.data.id ? resTask.data.id : null
            await TaskService.post(this.task2)
          }
        }
        // await EmailService.sendemail(this.task)
         if (this.$store.state.editItem === 1) {
          const resTask = await TaskService.put(this.task)
          console.log('resTask', resTask)
        }

        // Obavijest ide tek nakon sto je zadatak zapisan: ako posta zakaze,
        // posao je svejedno evidentiran i obavijest se moze ponoviti.
        if (this.posaljiObavijest && zapisaniId) {
          try {
            const {data} = await TaskService.taskobavijest(zapisaniId, {
              na: this.task.taskNotifyEmail,
              First: this.$store.state.user ? this.$store.state.user.First : '',
              Last: this.$store.state.user ? this.$store.state.user.Last : '',
              email: this.$store.getters.NeedUseremail
            })
            this.poruka = {vidi: true, boja: 'success',
              tekst: this.langC.TaskNotifySent + ' ' + data.na}
          } catch (err) {
            const o = err && err.response && err.response.data
            // Zadatak JE spremljen - to se mora reci, inace operater pomisli
            // da nista nije prosla i upise ga ponovno.
            this.poruka = {vidi: true, boja: 'warning',
              tekst: (o && o.error ? o.error : this.langC.TaskNotifyFailed) +
                ' (zadatak je spremljen)'}
            this.spremam = false
            return
          }
        }

        // Novi zadatak mijenja brojcic uz ikonu korisnika.
        await this.osvjeziBrojcic()

        this.havePath = this.$store.state.retPath
        this.$store.dispatch('setretPath', '')

        if (zaduzenje === 'niciji') {
          // Zadatak bez izvrsitelja nitko nece vidjeti - to se mora javiti.
          this.poruka = {vidi: true, boja: 'warning', tekst: this.langC.TaskNobodyAssigned}
          this.spremam = false
          return
        }

        this.$router.push({
            name: 'home'
        })

        // if (this.havePath !== 'task' && this.havePath.length > 0) {
        //   this.$router.push({
        //     name: 'home'
        //   })
        // } else {
        //   this.$router.push({
        //     name: 'task'
        //   })
        // }
      } catch (error) {
        this.error = 'Greska u konekciji na bazu'
      } finally {
        this.spremam = false
      }
    },
    async osvjeziBrojcic () {
      try {
        const {data} = await TaskService.taskceka({UserId: this.$store.getters.NeedUserID})
        this.$store.dispatch('setTaskCeka', data)
      } catch (err) {
        // Brojcic nije vrijedan rusenja spremanja.
        // eslint-disable-next-line
        console.log(err)
      }
    },
    close () {
      this.show = false
    },
    async tasklist () {
      try {
        this.havePath = this.$store.state.retPath
        this.$store.dispatch('setretPath', '')
         this.$router.push({
            name: 'home'
        })
        // if (this.havePath !== 'task' && this.havePath.length > 0) {
        //   await this.$router.push({
        //     name: this.havePath
        //   })
        // } else {
        //   await this.$router.push({
        //     name: 'task'
        //   })
        // }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  watch: {

  }
}
</script>

<style scoped>
.traka {
  background: #0d47a1;
  color: #fff;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  border-radius: 4px 4px 0 0;
}
.naslov { font-size: 18px; font-weight: 500; margin: 0; }
.podatak { margin-left: auto; font-size: 12px; opacity: .85; }

.napomena { font-size: 12px; color: #5f6b7a; font-style: italic; line-height: 1.4; }

/* Zeleni blok: zadatak koji je vec obavljen i samo se evidentira. */
.obavljeno-blok {
  border: 1px solid #c8e6c9;
  background: #f6fbf6;
  border-radius: 4px;
  padding: 10px 12px;
  margin-top: 10px;
}

.pregled-poruke {
  background: #fff;
  border: 1px dashed #c5d2de;
  border-radius: 3px;
  padding: 8px 10px;
  margin-top: 6px;
  font-size: 12px;
  color: #455a64;
  line-height: 1.5;
}
.pregled-naslov { color: #5f6b7a; margin-bottom: 4px; }

/* Sklopive skupine bez Vuetifyjeve sjene, da izgledaju kao dio kartice. */
.sklopivo >>> .v-expansion-panel-header {
  min-height: 40px;
  padding: 8px 12px;
  font-weight: 500;
  color: #1565c0;
}
.sklopivo >>> .v-expansion-panel { border-top: 1px solid #e3e8ee; }
</style>
